<template>
  <div class="sme-tabs">
    <ul class="sme-tabs__list">
      <li
        class="sme-tabs__item"
        :class="{ 'active': isActive(index), 'disabled': tab.disabled }"
        v-for="(tab, index) in tabList"
        v-bind="tab.dataAttrs"
        @click="select(index)"
        :key="index"
      >{{ tab.title }}</li>
    </ul>
    <div class="sme-tabs__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sme-tabs',

  data () {
    return {
      tabList: [],
      activeTabIndex: 0
    }
  },

  mounted () {
    this.select(0)
    this.activeTabIndex = this.getInitialActiveTab()

    this.$root.$on('select-tab', index => this.select(index))
  },

  methods: {
    isActive (index) {
      return this.activeTabIndex === index
    },

    select (index) {
      const tab = this.tabList[index]
      if (!tab.isDisabled) {
        this.activeTabIndex = index
      }
    },

    getInitialActiveTab () {
      const index = this.tabList.findIndex(tab => tab.active)
      return index === -1 ? 0 : index
    }

  }
}
</script>

<style lang="scss" scoped>
$border-color: #ccc;
$primary-color: #39f;

.sme-tabs {
  &__list {
    display: flex;
    padding: 0;
    margin: 0;
    list-style-type: none;
  }

  &__item {
    font-size: 14px;
    padding: 2px 8px;
    border-bottom: 1px solid transparent;
    line-height: normal;
    cursor: pointer;
    transition: all .3s;

    &:hover {
      background-color: #f3f3f3;
    }

    &.active {
      border-color: #39f;
      background-color: #f3f3f3;
    }
  }

  &__content {
    margin-top: 10px;
  }
}
</style>
